import { useQuery, useMutation } from "@tanstack/react-query"
import { getBillingPlans, createPaymentUrl, createSubscriptionUrl, listCreditHistory } from "@/lib/http/billing"
import { BillingPlans, PaginatedCreditHistory, PaymentUrlResponse, SubscriptionUrlResponse } from "@/types/api"

export const useBillingPlans = () => {
  return useQuery<BillingPlans>({
    queryKey: ["billing", "plans"],
    queryFn: getBillingPlans,
    staleTime: 5 * 60 * 1000, // 5 minutes
  })
}

export const useCreatePaymentUrl = () => {
  return useMutation<PaymentUrlResponse, Error, string>({
    mutationFn: createPaymentUrl,
    onSuccess: (data) => {
      window.location.href = data.url
    },
  })
}

export const useCreateSubscriptionUrl = () => {
  return useMutation<SubscriptionUrlResponse, Error, void>({
    mutationFn: createSubscriptionUrl,
    onSuccess: (data) => {
      window.location.href = data.url
    },
  })
}

export const useListCreditHistory = (limit: number = 10, offset: number = 0) => {
  return useQuery<PaginatedCreditHistory>({
    queryKey: ["billing", "credit-history", limit, offset],
    queryFn: () => listCreditHistory(limit, offset),
  })
}
